import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subject, pipe } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WINDOW } from '../_providers/window.provider';

// import { TWADialogsModule } from 'twa-md2-dialogs';
import { TWADialogsService } from './twa-dialogs.service';

import { LoaderService } from './loader/loader.service';
// import { WindowRef } from './windowref.service';

export interface IRequestOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  body?: any;
}

export interface APIErrorDef {
  code: number;
  description: string;
}

export interface APIResponse {
  result: boolean;
  data: any;
  error?: APIErrorDef;
}

export function serverConnCreator(
  http: HttpClient,
  router: Router,
  loaderService: LoaderService,
  // windowRef: WindowRef,
  window: Window,
  dlgsSvc: TWADialogsService,
  afAuth: AngularFireAuth,
  snackBar: MatSnackBar,
  ) {
  return new ServerConn(http, router, loaderService, window, dlgsSvc, afAuth, snackBar);
}

@Injectable({
  providedIn: 'root'
})
export class ServerConn implements OnDestroy {
  // public serverUrl = window.location.protocol + '//dummy-api-server.com/v1/';
  // public serverUrl = window.location.protocol + '//api.azasa.com/v1/';
  // public serverUrl = window.location.protocol + '//api.dev.azasa.com/v1/';
  public serverUrl = 'https://app.nvio.ai/';
  // public serverUrl = window.location.protocol + '//api.arana.ganaderos.sira.es/v1/';
  // public serverUrl = 'https://api.arana.ganaderos.sira.es/v1/';
  // public serverUrl = 'http://' +  + '/v1/';
  private headers: any;
  private unsubscribe: Subject<boolean> = new Subject();

  event401$: Subject<boolean> = new Subject();

  constructor(
    private http: HttpClient,
    private router: Router,
    private loaderService: LoaderService,
    @Inject(WINDOW) private window: Window,
    private dlgsSvc: TWADialogsService,
    private auth: AngularFireAuth,
    private snackBar: MatSnackBar,
  ) {
    console.log('🚀 ~ this.window:', this.window);
    if (this.window.location.hostname !== 'localhost') {
      if (
        this.window.location.hostname.substr(0, 4) === 'app.'
      ) {
        this.serverUrl =
          this.window.location.protocol +
          '//' +
          this.window.location.hostname
            .replace(/\.admin\./, '.')
            .replace(/^app\./, 'api.') +
          '/v1/';
      } else {
        this.serverUrl = 'https://app.nvio.ai/';
      }
      this.serverUrl = 'https://app.nvio.ai/';
    }
    this.createHeaders();
    this.event401$
    .pipe(
      takeUntil(this.unsubscribe)
    )
    .subscribe((data) => {
      if (data) {
        this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  createHeaders() {
    if (!this.auth) {
      setTimeout(() => {
        this.createHeaders();
      }, 500);
    } else {
      this.auth.idToken.subscribe((idToken) => {
        this.headers = new HttpHeaders({
          Authorization: 'Bearer ' + idToken,
        });
      });
      // this.auth.user.subscribe((user: any) => {
      //   this.headers = new HttpHeaders({
      //     Authorization: 'Bearer ' + user.uid,
      //   });
      // });
    }
  }

  clearHeaders() {
    this.headers = new HttpHeaders({
      Authorization: 'Bearer none',
    });
  }

  isJson(value: any): boolean {
    return /\bapplication\/json\b/.test(value.headers.get('Content-Type'));
  }

  private showLoader(): void {
    this.loaderService.show();
  }

  private hideLoader(): void {
    this.loaderService.hide();
  }

  private onEnd(): void {
    this.hideLoader();
  }

  private onError(err: any = false): void {
    if (err === false) {
      err = {
        error: 'Se ha producido un error de conexión con el servidor'
      };
    } else {
      err.error = 'Error de conexión: ' + err.error;
    }
    this.hideLoader();
    this.snackBar.open(
      err.error,
      '',
      {
        duration: 5000
      }
    );
    // this.dlgsSvc
    //   .confirm(
    //     'Error de conexión con el servidor',
    //     'Se ha producido un error de conexión con el servidor, si el problema persiste contacte con nosotros.' +
    //     (err && err.error ? "\n<code>" + err.error + "</code>" : ''),
    //     'Cerrar'
    //   )
    //   .subscribe(() => {});
  }

  get(action: string | Request, params?: any, cancelSubscription = false, extraOptions: any = false) {
    // const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    if (!this.headers) {
      return new Observable((observer) => {
        observer.next(false);
      });
    }

    const headers = this.headers.set(
      'Content-Type',
      'text/plain'
      // 'application/x-www-form-urlencoded'
    );
    let options: any | undefined = { headers: headers };
    if (extraOptions) {
      options = {...options, ...extraOptions};
    }

    const paramsObj = new URLSearchParams();
    let key;

    if (typeof params === 'undefined') {
      params = {};
    }

    for (key in params) {
      if (typeof params[key] !== 'undefined') {
        paramsObj.set(key, params[key]);
      }
    }

    if (cancelSubscription) {
      this.unsubscribe.next(true);
    }

    this.showLoader();

    return new Observable((observer) => {
      let url = (action.toString().substring(0, 5) == 'https' || action.toString().substring(0, 4) == 'http') ? action : this.serverUrl + action;
      if (url.toString().substring(0, 5) === 'http:' && !url.toString().includes('localhost')) {
        options = undefined;
      }
      if (paramsObj.toString() > '') {
        url = url + '?' + paramsObj.toString();
      }
      this.http
        // .get(url.toString(), options)
        .get(url.toString(), options)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => observer.next(res), // simply passing success response
          (err) => {
            // error handling
            console.log('global error handler', err);
            if (
              err.statusText === 'Unauthorized' ||
              err.status === 401 ||
              err.status === 401
            ) {
              localStorage.removeItem('api_key');
              localStorage.removeItem('user');
              this.event401$.next(true);
              // this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
            } else {
              this.onError();
            }
            observer.error(err); // passing error to the method which invoked request
          },
          () => {
            this.onEnd();
            observer.complete();
          } // passing onComplete event);
        );
    });
  }

  checkError(err: any) {
    if (err.statusText === 'Unauthorized' || err.status === 401) {
      localStorage.removeItem('api_key');
      localStorage.removeItem('user');
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }

  post(action: string | Request, params?: any, cancelSubscription = false, extraOptions: any = false) {
    // const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const headers = this.headers.append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    let options = { headers: headers };
    if (extraOptions) {
      options = {...options, ...extraOptions};
    }
    const paramsObj = new URLSearchParams();
    let key;

    if (typeof params === 'undefined') {
      params = {};
    }

    for (key in params) {
      if (typeof params[key] !== 'undefined') {
        paramsObj.set(key, params[key]);
      }
    }

    if (cancelSubscription) {
      this.unsubscribe.next(true);
    }

    this.showLoader();

    return new Observable((observer) => {
      let url = (action.toString().substring(0, 5) == 'https' || action.toString().substring(0, 4) == 'http') ? action.toString() : this.serverUrl + action;
      this.http
        .post(url, paramsObj.toString(), options)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => observer.next(res), // simply passing success response
          (err) => {
            // error handling
            console.log('global error handler', err);
            if (
              err.statusText === 'Unauthorized' ||
              err.status === 401 ||
              err.status === 401
            ) {
              localStorage.removeItem('api_key');
              localStorage.removeItem('user');
              this.event401$.next(true);
              //    this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
            } else {
              this.onError();
            }
            observer.error(err); // passing error to the method which invoked request
          },
          () => {
            this.onEnd();
            observer.complete();
          } // passing onComplete event);
        );
    });
  }

  postBody(action: string | Request, params?: any, cancelSubscription = false) {
    // const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const headers = this.headers.append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    const options = { headers: headers };
    const paramsObj = params;
    let key;

    if (typeof params === 'undefined') {
      params = {};
    }

    // for (key in params) {
    //   if (typeof params[key] !== 'undefined') {
    //     paramsObj.set(key, params[key]);
    //   }
    // }

    if (cancelSubscription) {
      this.unsubscribe.next(true);
    }

    this.showLoader();

    return new Observable((observer) => {
      let url = (action.toString().substring(0, 5) == 'https' || action.toString().substring(0, 4) == 'http') ? action.toString() : this.serverUrl + action;
      this.http
        .post(url, paramsObj, options)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => observer.next(res), // simply passing success response
          (err) => {
            // error handling
            console.log('global error handler', err);
            if (
              err.statusText === 'Unauthorized' ||
              err.status === 401 ||
              err.status === 401
            ) {
              localStorage.removeItem('api_key');
              localStorage.removeItem('user');
              this.event401$.next(true);
              //    this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
            } else {
              this.onError();
            }
            observer.error(err); // passing error to the method which invoked request
          },
          () => {
            this.onEnd();
            observer.complete();
          } // passing onComplete event);
        );
    });
  }

  put(action: string | Request, params?: any) {
    // const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const headers = this.headers.append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    const options = { headers: headers };
    const paramsObj = new URLSearchParams();
    let key;

    if (typeof params === 'undefined') {
      params = {};
    }

    // params.a = action;
    // params.api_key = localStorage.getItem('api_key');

    // if (this.isJson(params)) {
    for (key in params) {
      if (typeof params[key] !== 'undefined') {
        // paramsObj.set(key, params[key]);
        paramsObj.set(key, params[key]);
      }
    }

    this.showLoader();

    return new Observable((observer) => {
      let url = (action.toString().substring(0, 5) == 'https' || action.toString().substring(0, 4) == 'http') ? action.toString() : this.serverUrl + action;
      this.http
        .put(url, paramsObj.toString(), options)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => observer.next(res), // simply passing success response
          (err) => {
            // error handling
            console.log('global error handler');
            if (
              err.statusText === 'Unauthorized' ||
              err.status === 401 ||
              err.status === 401
            ) {
              localStorage.removeItem('api_key');
              localStorage.removeItem('user');
              this.event401$.next(true);
              //    this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
            } else {
              this.onError();
            }
            observer.error(err); // passing error to the method which invoked request
          },
          () => {
            this.onEnd();
            observer.complete();
          } // passing onComplete event);
        );
    });
  }

  delete(action: string | Request, params?: any) {
    // const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const headers = this.headers.append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    const options = { headers: headers };
    const paramsObj = new URLSearchParams();
    let key;

    if (typeof params === 'undefined') {
      params = {};
    }

    // params.api_key = localStorage.getItem('api_key');

    for (key in params) {
      if (typeof params[key] !== 'undefined') {
        paramsObj.set(key, params[key]);
      }
    }

    this.showLoader();

    return new Observable((observer) => {
      let url = (action.toString().substring(0, 5) == 'https' || action.toString().substring(0, 4) == 'http') ? action : this.serverUrl + action;
      if (paramsObj.toString() > '') {
        url = url + '?' + paramsObj.toString();
      }
      this.http
        .delete(url.toString(), options)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => observer.next(res), // simply passing success response
          (err) => {
            // error handling
            console.log('global error handler');
            if (
              err.statusText === 'Unauthorized' ||
              err.status === 401 ||
              err.status === 401
            ) {
              localStorage.removeItem('api_key');
              localStorage.removeItem('user');
              this.event401$.next(true);
              //    this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
            } else {
              this.onError();
            }
            observer.error(err); // passing error to the method which invoked request
          },
          () => {
            this.onEnd();
            observer.complete();
          } // passing onComplete event);
        );
    });
  }

  upload(action: any, formData: any) {

    // const headers = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
    // const headers = new HttpHeaders({ 'Content-Type': undefined });
    // const options = { headers: headers};
    // const headers = this.headers.append(
    //   'Content-Type',
    //   'multipart/form-data'
    // );
    const options = { headers: this.headers };

    this.showLoader();

    return new Observable((observer: any) => {
        // this.http.post(this.serverUrl + action + '?api_key=' + api_key, formData, options).subscribe(
        let url = (action.toString().substring(0, 5) == 'https' || action.toString().substring(0, 4) == 'http') ? action : this.serverUrl + action;
        this.http.post(url, formData, options).subscribe(
            res => observer.next(res), // simply passing success response
            err => { // error handling
              console.log('global error handler', err);
              if (err.statusText === 'Unauthorized' || err.status === 401 || err.status === 401) {
                  localStorage.removeItem('api_key');
                  localStorage.removeItem('user');
                  this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
              } else {
                this.onError(err);
              }
              this.onEnd();
              observer.error(err); // passing error to the method which invoked request
            },
            () => {
                this.onEnd();
                observer.complete()
            } // passing onComplete event);
        );
    });
  }

  download(action: string | Request, params?: any, cancelSubscription = false) {
    // const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const headers = this.headers.append(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    let options: any = {
      headers: headers,
      responseType: 'blob' as 'json',
      observe: 'response' as 'body',
    };
    const paramsObj = new URLSearchParams();
    let key;

    if (typeof params === 'undefined') {
      params = {};
    }

    // params.a = action;
    // params.api_key = localStorage.getItem('api_key');

    // if (
    //   typeof params.api_key === 'undefined' ||
    //   !params.api_key ||
    //   params.api_key === null ||
    //   params.api_key === ''
    // ) {
    //   // this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
    //   return new Observable();
    //   // exit;
    // }
    if (cancelSubscription) {
      this.unsubscribe.next(true);
    }

    // if (this.isJson(params)) {
    for (key in params) {
      if (typeof params[key] !== 'undefined') {
        paramsObj.set(key, params[key]);
      }
    }

    this.showLoader();

    return new Observable((observer) => {
      let url = (action.toString().substring(0, 5) == 'https' || action.toString().substring(0, 4) == 'http') ? action : this.serverUrl + action;
      if (url.toString().substring(0, 5) === 'http:' && !url.toString().includes('localhost')) {
        options = undefined;
      }
      if (paramsObj.toString() > '') {
        url = url + '?' + paramsObj.toString();
      }
      this.http
        .get(url.toString(), options)
        // .get(this.serverUrl + action + '?' + paramsObj.toString(), options)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res: any) => {
            return observer.next(res);
          }, // simply passing success response
          (err) => {
            // error handling
            console.log('global error handler', err);
            if (
              err.statusText === 'Unauthorized' ||
              err.status === 401 ||
              err.status === 401
            ) {
              localStorage.removeItem('api_key');
              localStorage.removeItem('user');
              this.event401$.next(true);
              //    this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
            } else {
              this.onError();
            }
            observer.error(err); // passing error to the method which invoked request
          },
          () => {
            this.onEnd();
            observer.complete();
          } // passing onComplete event);
        );
    });
  }  
}
